import clsx from 'clsx'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect, Route, Switch, generatePath, useLocation, useParams } from 'react-router-dom'

import { LayoutMain } from '@flatsy/core'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import * as ROUTES from 'src/constants/Routes'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import { AlertSlice } from 'src/redux/slices/Alert'
import { applicationSlice } from 'src/redux/slices/Application'
import { AppDispatch } from 'src/utils/AppDispatch'

import NewReschedule from '../Qualification/Steps/Booking/NewReschedule'
import Booking from './Booking'
import Cancel from './Booking/Cancel'
import Cancelled from './Booking/Cancelled'
import Files from './Files'
import Navigation from './Navigation'
import PostInterest from './PostInterest'
import { useStyles } from './Style'
import { FlashMessageCreatedFor } from './Type'

const Application: React.FC = () => {
  const classes = useStyles()
  const { applicationId } = useParams<{
    applicationId: string
  }>()
  const { asset, qualification, application } = useApplicationDetails()
  const location = useLocation()
  const isCancelledPage = location.pathname.includes('cancelled')
  const isCancelPage = location.pathname.includes('cancel')
  const isConfirmIdentityPage = location.pathname.includes('confirm_identity')
  const displayNavigationHeader = !isConfirmIdentityPage && !isCancelPage
  const { flash_messages } = application.application
  const dispatch: AppDispatch = useDispatch()

  const dispatchPostInterest = () => {
    dispatch(
      AlertSlice.actions.setAlert({
        severity: 'info',
        content: 'Votre intérêt a été transmis à l’agence',
        open: true,
        icon: (
          <img
            src={FlatsyTheme.image.iconTask}
            className={classes.iconTask}
            alt="icon-checkmark-green"
          />
        ),
      })
    )
  }

  useEffect(() => {
    if (application.postBookingInterestFromMail) {
      dispatchPostInterest()
      dispatch(applicationSlice.actions.setPostBookingInterestFromMailToFalse())
    }
  }, [application.postBookingInterestFromMail])

  const shouldRedirectToNewReschedule = () => {
    if (
      flash_messages &&
      flash_messages?.length > 0 &&
      flash_messages.find(
        (message) => message.created_for === FlashMessageCreatedFor.RESCHEDULED_BY_AGENT
      )
    ) {
      return (
        <Redirect
          to={{
            pathname: generatePath(ROUTES.APPLICATION_BOOKING_NEW_RESCHEDULE, {
              applicationId,
            }),
          }}
        />
      )
    }
    return (
      <Redirect
        to={{
          pathname: generatePath(ROUTES.APPLICATION_BOOKING, {
            applicationId,
          }),
        }}
      />
    )
  }

  return (
    <>
      {displayNavigationHeader && (
        <Navigation asset={asset} applicationId={applicationId} qualification={qualification} />
      )}
      <LayoutMain
        className={clsx(
          classes.main,
          isCancelPage && !isCancelledPage && classes.cancelMain,
          isCancelledPage && classes.cancelledMain
        )}
      >
        <Switch>
          <Route exact path={ROUTES.APPLICATION_INTEREST} component={PostInterest} />
          <Route exact path={ROUTES.APPLICATION}>
            {shouldRedirectToNewReschedule()}
          </Route>
          <Route exact path={ROUTES.APPLICATION_BOOKING} component={Booking} />
          <Route exact path={ROUTES.APPLICATION_BOOKING_NEW_RESCHEDULE} component={NewReschedule} />
          <Route exact path={ROUTES.APPLICATION_DOSSIER} component={Files} />
          <Route path={ROUTES.APPLICATION_DOSSIER_CANCEL} component={Cancel} />
          <Route path={ROUTES.APPLICATION_DOSSIER_CANCELLED} component={Cancelled} />
          <Redirect to={{ pathname: ROUTES.NOT_FOUND }} />
        </Switch>
      </LayoutMain>
    </>
  )
}

export default Application
